<template>
  <div class="opening-screen" :class="{ 'opening-screen--out': leaving }" @click="finish" @animationend.self="onEnd">
    <svg class="opening-screen__logo" :viewBox="horizontal.viewBox" role="img" aria-label="Mantraz">
      <g
        v-for="(wave, i) in waves"
        :key="wave.key"
        class="opening-screen__wave"
        :style="{ '--i': i }"
      >
        <g :transform="horizontal.iconTransform">
          <path :d="wave.d" :transform="transform" :fill="wave.color" />
        </g>
      </g>
      <g :transform="wordmark.groupTransform">
        <path
          v-for="(letter, i) in wordmark.letters"
          :key="i"
          class="opening-screen__letter"
          :style="{ '--i': i }"
          :d="letter.d"
          :transform="letter.transform"
          fill="var(--mz-logo-ink)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import {
  LOGO_WAVES, LOGO_TRANSFORM, LOGO_HORIZONTAL, LOGO_WORDMARK,
} from '@/util/auth/brandLogoPaths';

const PLAY_MS = 2300;

export default {
  name: 'OpeningScreen',
  data() {
    return {
      waves: LOGO_WAVES,
      transform: LOGO_TRANSFORM,
      horizontal: LOGO_HORIZONTAL,
      wordmark: LOGO_WORDMARK,
      leaving: false,
      timer: null,
      guard: null,
    };
  },
  mounted() {
    this.timer = setTimeout(this.finish, PLAY_MS);
    window.addEventListener('keydown', this.onKey);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.guard);
    window.removeEventListener('keydown', this.onKey);
  },
  methods: {
    onKey(e) {
      if (e.key === 'Escape') this.finish();
    },
    finish() {
      if (this.leaving) return;
      clearTimeout(this.timer);
      this.leaving = true;
      // jaga-jaga kalau animationend gak pernah nembak
      this.guard = setTimeout(() => this.$emit('done'), 600);
    },
    onEnd() {
      if (this.leaving) {
        clearTimeout(this.guard);
        this.$emit('done');
      }
    },
  },
};
</script>

<style>
.opening-screen {
  position: fixed; inset: 0; z-index: 2000;
  display: grid; place-items: center;
  background: var(--mz-surface); cursor: pointer;
}
.opening-screen--out { animation: mz-opening-out .4s ease forwards; }
@keyframes mz-opening-out { to { opacity: 0; visibility: hidden; } }
.opening-screen__logo { width: min(640px, 80vw); height: auto; }
.opening-screen__wave {
  clip-path: inset(0 100% 0 0) fill-box;
  animation: mz-wave-draw 1s cubic-bezier(.65, 0, .35, 1) forwards;
  animation-delay: calc(var(--i) * 0.1s);
}
@keyframes mz-wave-draw { to { clip-path: inset(0 0 0 0) fill-box; } }
.opening-screen__letter {
  opacity: 0;
  translate: 0 60px;
  animation: mz-letter-rise .5s ease-out forwards;
  animation-delay: calc(0.9s + var(--i) * 0.08s);
}
</style>
